module.exports = __webpack_public_path__ + "static/media/man_pengxunzhi.17181fd6.png";